import { BG_COLORS } from '@constants';
import PagepartBase from '@molecules/PagepartBase/PagepartBase';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import styles from './WhatToExpectSection.module.scss';

function WhatToExpectSection({ list, backgroundColor, id }) {
  if (!list?.length) return null;

  const renderSvg = (svgValue, className) => {
    try {
      const DynamicSvg = dynamic(() => import(`@svg/${svgValue}.svg`));
      return <DynamicSvg key={svgValue} className={className} />;
    } catch (error) {
      console.error(`Failed to load SVG: ${svgValue}`, error);
      return null;
    }
  };

  return (
    <PagepartBase backgroundColor={backgroundColor.color} id={id}>
      <div className={styles.card}>
        {list?.map(item => (
          <div className={styles.itemContainer} key={item.title}>
            {!!item.icon && renderSvg(item.icon.icon, styles.icon)}
            <h4>{item.title}</h4>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </PagepartBase>
  );
}

WhatToExpectSection.propTypes = {
  id: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      icon: PropTypes.shape({
        icon: PropTypes.string.isRequired,
      }),
    })
  ),
  backgroundColor: PropTypes.shape({
    color: PropTypes.oneOf(BG_COLORS),
  }).isRequired,
};

export default WhatToExpectSection;
